var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{style:(`max-width: ${_vm.maxWidth} !important;`),attrs:{"width":_vm.width,"type":"donut","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }